import { postJsMessage } from '../../bridge';
import API from '../../api';
import { PostMessageOption } from '../../types';
import { ERROR_CODE, genErrorMessage } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * http.request
 *
 * [PLATFORM]
 * mac        6.2.5+
 * windows    6.2.5+
 * linux      6.2.5+
 * ios        6.2.5+
 * android    6.2.5+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function request(params: HttpRequest, options?: PostMessageOption) {
  const { url, method = 'GET' } = params;

  if (url) {
    return postJsMessage<
      HttpRequest,
      Promise<NativeAPIResponseMessage<HttpResponse>>
    >(API.request, { ...params, method }, options);
  } else {
    return Promise.reject(
      genErrorMessage({
        errorCode: ERROR_CODE.REQUEST_PARAM_ERROR,
        apiName: API.request,
        message: `url can't be empty!`,
      })
    );
  }
}

export type HttpRequest = {
  url: string;
  headers: {
    [key: string]: string;
  };
  body: {
    [key: string]: string;
  };
  needZak: boolean;
  method:
    | 'GET'
    | 'POST'
    | 'PUT'
    | 'DELETE'
    | 'HEAD'
    | 'OPTIONS'
    | 'PATCH'
    | 'TRACE'
    | 'CONNECT';
};

export type HttpResponse = {
  data: {
    [key: string]: string;
  };
};

export default {
  request,
};
